import React from "react";
import "animate.css";
function DeliveryInfo(props) {
  return (
    <div className="bg-gray-100 py-8 px-4 lg:px-0 md:mb-6 animate__animated animate__fadeIn">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-semibold mb-4">
          Жеткирүү жана орнотуу
        </h2>
        <h2 className="font-semibold text-lg mb-6">Бишкек шаарында:</h2>
        <ol className="list-disc pl-6 mb-4">
          <li>Жеткирүү, чогултуу жана орнотуу — толугу менен БЕКЕР!</li>
          <li>Жеткирүү убактысы алдын ала макулдашылат.</li>
        </ol>
        <h2 className="font-semibold text-lg mb-6">Кыргызстан боюнча региондорго жеткирүү:</h2>
        <ol className="list-disc pl-6 mb-4">
          <li>Жеткирүү — кошумча акы менен.</li>
          <li>Чогултуу жана орнотуу — БЕКЕР!</li>
          <li>Алыстагы аймактарга курьер аркылуу жөнөтүлөт.</li>
        </ol>
        <p>Маалымат үчүн бизге кайрылыңыз.</p>
        <h2 className="font-semibold text-lg mb-6">📌 Мөөнөт:</h2>
        <ol className="list-disc pl-6 mb-4">
          <li>
            {" "}
            Буйрутма толук төлөнгөндөн кийин, жеткирүү 15-20 иш күндүн ичинде
            аткарылат.
          </li>
          <li>Биздин кызматтарыбыз менен ыңгайлуулукту сезиңиз! 😊</li>
        </ol>
      </div>
    </div>
  );
}

export default DeliveryInfo;
